<p-dialog
  #fastTabelaPreco
  [modal]="true"
  [visible]="true"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">Adicionar tabela de preço</span>
      <i class="mdi mdi-account-multiple-outline ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="row">
    <div class="col-md-12">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Nome</mat-label>
        <input
          matInput
          (blur)="actionFnCheckEntityExist(form.get('nome'))"
          type="text"
          [formControl]="form.get('nome')"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('nome').touched && form.get('nome').hasError('required')
        "
      >
        {{ messages.nome.required }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('nome').touched && form.get('nome').hasError('maxlength')
        "
      >
        {{ messages.nome.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('nome').touched && form.get('nome').hasError('isEmptyValue')
        "
      >
        {{ messages.nome.isEmptyValue }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('nome').touched && form.get('nome').hasError('duplicate')
        "
      >
        {{ messages.nome.duplicate }}
      </small>
    </div>
    <!-- <div class="col-md-12 mt-2">
      <mat-form-field class="w-100" appearance="outline" floatLabel="always">
        <mat-label>Acréscimo/Desconto</mat-label>
        <input
          class="text-right"
          matInput
          id="perc_desc_acresc"
          [formControl]="form.get('perc_desc_acresc')"
          (keydown)="validateNumbers($event)"
        />
        <span matSuffix>%</span>
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('perc_desc_acresc').touched &&
          form.get('perc_desc_acresc').hasError('required')
        "
      >
        {{ messages.perc_desc_acresc.required }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('perc_desc_acresc').touched &&
          form.get('perc_desc_acresc').hasError('pattern')
        "
      >
        {{ messages.perc_desc_acresc.pattern }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('perc_desc_acresc').touched &&
          form.get('perc_desc_acresc').hasError('before_split')
        "
      >
        {{ messages.perc_desc_acresc.before_split }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('perc_desc_acresc').touched &&
          form.get('perc_desc_acresc').hasError('after_split')
        "
      >
        {{ messages.perc_desc_acresc.after_split }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('perc_desc_acresc').touched &&
          form.get('perc_desc_acresc').hasError('errorComma')
        "
      >
        {{ messages.perc_desc_acresc.errorComma }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('perc_desc_acresc').touched &&
          form.get('perc_desc_acresc').hasError('errorDots')
        "
      >
        {{ messages.perc_desc_acresc.errorDots }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('perc_desc_acresc').touched &&
          form.get('perc_desc_acresc').hasError('max_value')
        "
      >
        {{ messages.perc_desc_acresc.max_value }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('perc_desc_acresc').touched &&
          form.get('perc_desc_acresc').hasError('notNumbers')
        "
      >
        {{ messages.perc_desc_acresc.notNumbers }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('perc_desc_acresc').touched &&
          form.get('perc_desc_acresc').hasError('invalidNumber')
        "
      >
        {{ messages.perc_desc_acresc.invalidNumber }}
      </small>
    </div> -->
  </div>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        mat-dialog-close
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
        [disabled]="loading"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="onSubmit()"
        [disabled]="!form.valid || loading"
      ></button>
    </div>
  </ng-template>
</p-dialog>
